import {GLOBAL_SIDEBAR_STORAGE_KEY} from '@github-ui/layout-primitives/use-collapsible-sidebar-state'

/**
 * Issues/Projects alias for the site-wide {@link GLOBAL_SIDEBAR_STORAGE_KEY} —
 * they share one cookie rather than defining their own key.
 */
export const SIDEBAR_STORAGE_KEY = GLOBAL_SIDEBAR_STORAGE_KEY
